import Vue from 'vue'
import VueRouter from 'vue-router'
import share from '@/views/shareView'
import unilty from '@/views/unilty/unilty.vue'
import artlist from '@/views/artList/artlist.vue'
import webpage from '@/views/webpage/webpage.vue'
import workLib from '@/views/workLib/workLib.vue'
import workDetail from '@/views/workDetail/workDetail.vue'
import artinfo from '@/views/artInfo/artinfo.vue'
import privacyPolicy from '@/views/privacyPolicy/privacyPolicy.vue'
import gallery from '@/views/gallery/gallery.vue'
import authGallery from '@/views/authGallery/authGallery.vue'
import famousDetail from '@/views/famousDetail/famousDetail.vue'
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/share' },
  { path: '/share', name: 'share', component: share },
  { path: '/unilty', name: 'unilty', component: unilty },
  { path: '/artlist', name: 'artlist', component: artlist },
  { path: '/webpage', name: 'webpage', component: webpage },
  { path: '/workLib', name: 'workLib', component: workLib },
  { path: '/workDetail', name: 'workDetail', component: workDetail, mate: { title: '作品详情' } },
  { path: '/famousDetail', name: 'famousDetail', component: famousDetail, mate: { title: '名画赏析' } },
  { path: '/artinfo', name: 'artinfo', component: artinfo, mate: { title: '艺术头条' } },
  { path: '/privacy', name: 'privacy', component: privacyPolicy },
  { path: '/gallery', name: 'gallery', component: gallery },
  { path: '/authGallery', name: 'authGallery', component: authGallery, mate: { title: '官方美术馆' } }
]

const router = new VueRouter({
  routes
})
export default router
